import { FieldHasValue, ValidateField } from 'helpers/Validation';

export const FailureModeLowPassFailResult = (formData) => {
    if (FieldHasValue(formData.F814FaultAlarmHmi1) && FieldHasValue(formData?.F36FailureModeLc)) {
        if (ValidateField(formData.F814FaultAlarmHmi1) === 'Yes') {
            return 'Pass';
        }
        return 'Fail';
    }
    return '';
};
export const FailureModeHighPassFailResult = (formData) => {
    if (FieldHasValue(formData.F815FaultAlarmHmi2) && FieldHasValue(formData?.F33FailureModeHc)) {
        if (ValidateField(formData.F815FaultAlarmHmi2) === 'Yes') {
            return 'Pass';
        }
        return 'Fail';
    }
    return '';
};

export const isFailModeHighCurrentDisabled = (formData) => ((FieldHasValue(formData?.F36FailureModeLc)
    || FieldHasValue(formData?.F814FaultAlarmHmi1)) && !(FieldHasValue(formData?.F33FailureModeHc)
        || FieldHasValue(formData?.F815FaultAlarmHmi2)));

export const isFaultAlarmDisplayedHcRequired = (selectedTag, formData) => selectedTag?.FailureModeHighCurrentMA || (!selectedTag?.FailureModeHighCurrentMA
    && !selectedTag?.F36FailureModeLc) || !(FieldHasValue(formData?.F36FailureModeLc) && FieldHasValue(formData?.F814FaultAlarmHmi1));

export const isFaultAlarmDisplayedLcRequired = (selectedTag, formData) => selectedTag?.FailureModeLowCurrentMA || (!selectedTag?.FailureModeHighCurrentMA
    && !selectedTag?.F36FailureModeLc) || !(FieldHasValue(formData?.F33FailureModeHc) && FieldHasValue(formData?.F815FaultAlarmHmi2));

export const isFailModeLowCurrentDisabled = (formData) => ((FieldHasValue(formData?.F33FailureModeHc)
    || FieldHasValue(formData?.F815FaultAlarmHmi2)) && !(FieldHasValue(formData?.F36FailureModeLc)
        || FieldHasValue(formData?.F814FaultAlarmHmi1)));

export const isFailureModeHighCurrentRequired = (selectedTag, formData) => (FieldHasValue(formData?.F33FailureModeHc)
    && FieldHasValue(formData?.F36FailureModeLc)) || !(FieldHasValue(formData?.F36FailureModeLc)
        && (!selectedTag?.FailureModeLowCurrentMA && !selectedTag?.FailureModeHighCurrentMA))
    || (selectedTag?.FailureModeLowCurrentMA && selectedTag?.FailureModeHighCurrentMA) || (selectedTag?.FailureModeHighCurrentMA);

export const isFailureModeLowCurrentRequired = (selectedTag, formData) => (FieldHasValue(formData?.F33FailureModeHc)
    && FieldHasValue(formData?.F36FailureModeLc)) || !(FieldHasValue(formData?.F33FailureModeHc)
        && (!selectedTag?.FailureModeLowCurrentMA && !selectedTag?.FailureModeHighCurrentMA))
    || (selectedTag?.FailureModeLowCurrentMA && selectedTag?.FailureModeHighCurrentMA) || (selectedTag?.FailureModeLowCurrentMA);
